module.exports = __webpack_public_path__ + "img/bootstrapped_founder.a3cbc9e1.webp";